<template>
  <div class="table-responsive block">
    <datatable :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" :loading="loadDebts" @sort="sortBy" :fixed="true">
        <tbody>
          <tr v-for="(debt, index) in debts" :key="debt.id">
            <td>{{++index}}</td>
            <td class="text-center"><a :href="`debt/${debt.id}`" class="btn btn-sm btn-primary" target="_blank"> {{ $t('app.open') }}</a></td>
            <td>{{debt.number}}</td>
            <td>{{debt.debtor ? debt.debtor.fullname:''}}</td>
            <td>{{debt.status ? debt.status.name : ''}}</td>
            <td>
              {{debt.last_contact | dateFormat}}
            </td>
            <td>
              {{debt.next_contact | dateFormat}}<br>
              <span v-if="debt.next_contact == today" class="badge badge-pill badge-danger">{{ $t('app.today') }}</span>
              <span v-if="debt.next_contact == tomorrow" class="badge badge-pill badge-warning">{{ $t('app.tomorrow') }}</span>
            </td>
          </tr>
          <tr v-if="debts.length == 0 && !loadDebts">
            <td colspan="12" class="text-center">{{ $t('app.empty') }}</td>
          </tr>
        </tbody>
    </datatable>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      debts: [],
      today: moment().format('YYYY-MM-DD'),
      tomorrow: moment().add(1, 'days').format('YYYY-MM-DD'),
      columns: [
        { label: '#', name: 'index', disableOrder: true },
        { label: '', name: 'action', disableOrder: true },
        { label: this.$t('debts.number_short'), name: 'debts.number' },
        { label: this.$t('debtors.fullname'), name: 'debtors.fullname' },
        { label: this.$t('field.status'), name: 'debt_statuses.name' },
        { label: this.$t('debts.last_contact_short'), name: 'debts.last_contact' },
        { label: this.$t('debts.next_contact_short'), name: 'debts.next_contact' },
      ],
      sortKey: 'name',
      sortOrders: {},
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 6,
        dir: 'asc',
      },
      loadDebts: false,
    };
  },
  created() {
    this.fetchDebts();
    this.columns.forEach((column) => {
      this.sortOrders[column.name] = -1;
    });
  },
  methods: {
    fetchDebts() {
      this.loadDebts = true;
      this.tableData.draw += 1;
      window.axios.get('/debts/nextcontact48hours', { params: this.tableData })
        .then((res) => {
          if (this.tableData.draw === res.data.draw) {
            this.debts = res.data.debts;
          } else {
            console.log('failed');
          }
        })
        .finally(() => {
          this.loadDebts = false;
        });
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.column = this.getIndex(this.columns, 'name', key);
      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
      this.fetchDebts();
    },
  },
};
</script>
